module.exports = __webpack_public_path__ + "static/media/er.e690960a.svg";